import { autocompleteClientName } from 'wisestep-api';
import { WsAutocompleteInput } from 'wisestep-base';

import { transformIClientDTOsToStringArray } from '../../../features/jobs/helper';
import WsFilterProps from '../models/WsFilterProps';

const ClientNamesFilter2 = ({
  name,
  multiple = false,
  placeHolder = 'Filter by Company Names',
}: WsFilterProps) => {
  const onClientNameInputKey = async (client: string) => {
    const result = await autocompleteClientName(
      `${encodeURIComponent(
        client
          .trim()
          .split(' ')
          .map((clientName) => clientName + ':*')
          .join(' & ')
      )}`
    );
    if (result?.data.length > 0) {
      const clientsList: string[] = transformIClientDTOsToStringArray(result.data);
      return clientsList;
    }
    return [];
  };
  return (
    <WsAutocompleteInput
      getOptions={onClientNameInputKey}
      placeholder={placeHolder}
      options={[]}
      multiple={multiple}
      size="small"
      name={name}
    />
  );
};
export default ClientNamesFilter2;
